import { CheckCircleFilled, LockOutlined } from "@ant-design/icons";
import { Tag } from "antd";

/** "Available" / "Available on request", the two states `can_open` can be in. */
export const DatasetAvailabilityTag = ({
  canOpen
}: {
  canOpen: boolean;
}) => canOpen ? <Tag className="m-0" color="success" icon={<CheckCircleFilled />}>
      Available
    </Tag> : <Tag className="m-0" color="default" icon={<LockOutlined />}>
      Available on request
    </Tag>;